<template>
  <div class="main">
    TEST PAGE CONTENT<br /><br />
    <br />
    <br />

    <Tabs
      activeId="tab23"
    >
      <Tab
        v-for="tab in tabs"
        :name="tab.name"
        :id="tab.id"
        :key="tab.id"
        v-html="tab.content"
        @active="alert( $event )"
      >
      </Tab>
    </Tabs>

    <Circlebar :value="percent" />

    <Dropdown
      title="sdkfjh sdfkdjf"
    >
      <template v-slot:opener1>sdfsdfsd</template>
      saasddas<br />
      saasddas<br />
      saasddas<br />
    </Dropdown>

    <Datetime
      :timeUse="true"
      :secondsUse="true"
      :moFirst="true"
      type="eng"
      :value="val1"
      @input="val1=$event"
    />

    <Datetime
      :timeUse="true"
      :secondsUse="true"
      :moFirst="false"
      type="rus"
      :value="val2"
      @input="val2=$event"
    />

<!--
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <Cal
        :moFirst="false"
    />

    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <Datetime
      :timeUse="true"
      :secondsUse="true"
      :moFirst="false"
      type="eng"
      :value="val"
      @input="val=$event"
    />

    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
-->
  </div>
</template>

<script>
import utils from "@/utils";

import Cal from "@/components/Calendar";
import Datetime from "@/components/Datetime";
import Dropdown from "@/components/Dropdown";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";

import Circlebar from "@/components/Circlebar";

export default {
  name:       "pageTest",
  components: {
    Cal,
    Datetime,
    Dropdown,
    Tabs,
    Tab,
    Circlebar
  },

  data() {
    return {
      percent: 0,

      val1: "",
      val2: "12.05.11 22:45:37",
      tabs: []
    };
  },

  created() {
    const tabs = [ "Свойства", "История", "Происхождение", "Граф", "Эталон" ];
    this.tabs = [];
    let c = 0;
    for ( const t of tabs ) {
      this.tabs.push(
        {
          name: t,
          id:     "tab" + c++,
          content: this.genRandText()
        }
      );
    }

    /**/
    for ( let i = 0; i < 20; i++ ) {
      this.tabs.push(
        {
          name: this.genRandWord(),
          id:     "tab" + c++,
          content: this.genRandText()
        }
      );
    }
    /**/
  },

  mounted() {
    let tid = setInterval(
      () => {
        this.percent++;
        if ( this.percent >= 100 ) clearInterval( tid );
      },
      100
    );
  },

  methods: {
    genRandWord() {
      return ( Math.random() + 1 ).toString( 36 ).substring( 7 );
    },
    genRandText() {
      let text = "";

      const words = Math.floor( Math.random() * 100 );
      for ( let w = 1; w < words; w++ ) {
        text += ( text ? " " : "" ) + this.genRandWord();
      }

      return text;
    },
    alert( t ) {
      //alert( t );
      console.log( "TAB", t );
    }
  },

  computed: {
  },

  watch: {
    val1() {
      console.log( "val1=" + this.val1 );
    },
    val2() {
      console.log( "val2=" + this.val2 );
    }
  }
};
</script>

<style scoped>
  .main {
    margin: 3em;
  }
</style>